import { c as _c } from "react/compiler-runtime";
import { Image, TextLink, TextPassage } from '@petsmart-ui/sparky';
import { useServicesLinkClick } from '../../../../shared';
import './service-card.scss';
export type ServiceCardModel = {
  href: string;
  imageUrl: string;
  openInNewTab?: boolean;
  title: string;
};
type ServiceCardProps = {
  card: ServiceCardModel;
  onClick?: () => void;
};
export function ServiceCard(t0) {
  const $ = _c(16);
  const {
    card,
    onClick
  } = t0;
  const handleServicesLinkClick = useServicesLinkClick();
  const t1 = card.openInNewTab ? "noopener noreferrer" : undefined;
  const t2 = card.openInNewTab ? "_blank" : undefined;
  let t3;
  if ($[0] !== card.href || $[1] !== card.openInNewTab || $[2] !== handleServicesLinkClick || $[3] !== onClick) {
    t3 = event => {
      handleServicesLinkClick({
        event,
        link: card.href,
        shouldOpenInNewTab: card.openInNewTab
      });
      onClick?.();
    };
    $[0] = card.href;
    $[1] = card.openInNewTab;
    $[2] = handleServicesLinkClick;
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== card.imageUrl) {
    t4 = <Image src={card.imageUrl} alt="" className="service-card__image" loading="lazy" />;
    $[5] = card.imageUrl;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== card.title) {
    t5 = <TextPassage className="service-card__title" align="center">{card.title}</TextPassage>;
    $[7] = card.title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== card.href || $[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <TextLink href={card.href} className="service-card" rel={t1} target={t2} onClick={t3}>{t4}{t5}</TextLink>;
    $[9] = card.href;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}